export const SAVE_OPPORTUNITIES_PATH = "/opportunities/save/:id?";

/** Query-параметр: контрагент, которым предзаполняется новая сделка. */
export const SAVE_OPPORTUNITY_COUNTERPARTY_PARAM = "counterparty";
